export default {
  cm_complete_validation: 'Please fill all the required fields before continuing',
  cm_balance_created: '%{code} sucessfully added to your balances',
  cm_error_occured: 'An error occurred. Please try again later.'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/common.js